// WorkedOnBy.jsx (drop-in replacement)
import "./WorkedOnBy.scss";
import { useTranslation } from "react-i18next";

const getInitials = (name = "") => {
    const parts = String(name).trim().split(/\s+/).filter(Boolean);
    const a = parts[0]?.[0] || "";
    const b = parts[1]?.[0] || parts[0]?.[1] || "";
    return (a + b).toUpperCase();
};

const WorkedOnBy = ({
    name,
    photoUrl,
    time_ago_xx,
    bg = null,
    showTitle = true,
    startFrom = "",
}) => {
    const { t } = useTranslation();
    const initials = getInitials(name);

    return (
        <div className={`worked-on-by ${startFrom}`}>
            {showTitle && (
                <div className="wob__title">
                    <span>{t("workedOnBy")}</span>
                </div>
            )}

            <div className={bg ? `wob__row ${bg}` : "wob__row"}>
                <div className="wob__avatar">
                    {photoUrl ? (
                        <img src={photoUrl} alt="" className="wob__img" />
                    ) : (
                        <span className="wob__initials">{initials || "?"}</span>
                    )}
                </div>

                <div className="wob__meta">
                    <span className="wob__name">{name}</span>
                    <span className="wob__time">{time_ago_xx}</span>
                </div>
            </div>
        </div>
    );
};

export default WorkedOnBy;
